import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function LandingPage() {
    return (
        <div className="flex min-h-screen flex-col md:flex-row bg-white">

            <div className="hidden md:flex flex-1 flex-col justify-center items-start text-left px-16 lg:px-20">
                <div className="max-w-xl">
                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tighter text-slate-900 leading-tight">
                        Career Readiness Platform
                    </h1>
                    <p className="mt-6 text-base md:text-lg text-slate-600">
                        AI Assisted Job Searches, Resume Review &amp; Mock Interview Prep
                    </p>
                </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center px-8 md:px-20 bg-slate-50 border-l border-slate-100">
                <div className="max-w-sm w-full">
                    {/* Logo */}
                    <img
                        src="/BizBrandIcon.jpg"
                        alt="Pono Pilot"
                        className="w-16 h-16 mb-12 rounded-2xl shadow-sm"
                    />

                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3 md:mb-8">
                        Join Pono Pilot.
                    </h2>

                    {/* Mobile-only: the left side's catchphrase is hidden below md,
                        so its message moves here instead of disappearing entirely. */}
                    <p className="md:hidden text-sm text-slate-600 mb-8">
                        Your career readiness platform with AI assisted job searches, resume review, and mock interview prep.
                    </p>

                    <div className="flex flex-col gap-4">
                        {/* Primary Action */}
                        <Button asChild variant="primary" className="w-full h-auto rounded-full py-3.5 px-6 text-lg shadow-md">
                            <Link to="/signup">Create Account</Link>
                        </Button>

                        <div className="relative flex items-center py-4">
                            <div className="flex-grow border-t border-slate-200"></div>
                            <span className="flex-shrink mx-4 text-slate-400 text-sm font-medium uppercase tracking-widest">or</span>
                            <div className="flex-grow border-t border-slate-200"></div>
                        </div>

                        {/* Secondary Action */}
                        <Button asChild variant="secondary" className="w-full h-auto rounded-full py-3.5 px-6 text-lg bg-white border border-border-soft text-primary hover:bg-primary-tint hover:text-primary">
                            <Link to="/login">Sign In</Link>
                        </Button>
                    </div>

                    <p className="mt-12 text-xs text-slate-500 leading-relaxed">
                        By signing up, you agree to our{' '}
                        <a
                            href="https://ponopilot.com/terms-of-service"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-600 underline hover:text-primary-700"
                        >
                            Terms of Service
                        </a>{' '}
                        and{' '}
                        <a
                            href="https://ponopilot.com/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-600 underline hover:text-primary-700"
                        >
                            Privacy Policy
                        </a>, including Cookie Use.
                    </p>
                </div>
            </div>

        </div>
    );
}
